import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Card, Container, Collapse, Row, Tab, Tabs,
} from 'react-bootstrap';

import PaymentTable from '../components/tables/PaymentTable';
import AccountDataForm from '../components/forms/AccountDataForm';
import PaymentDataForm from '../components/forms/PaymentDataForm';
import FormModal from '../components/modals/FormModal';
import ToolbarContainer from './tables/ToolbarContainer';

import loadPayments from '../actions/payments';
import { updatePage, updatePageSize } from '../actions/pagination';

import { Shapes } from '../models/entities';
import PaymentFilterContainer from './filters/PaymentFilterContainer';
import PaymentToolbar from '../components/toolbars/PaymentToolbar';

class AuditPayments extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showFilter: false,
      selectedId: undefined,
    };
    this.onDetails = this.onDetails.bind(this);
    this.onHideModal = this.onHideModal.bind(this);
    this.onClickButton = this.onClickButton.bind(this);
  }

  componentDidMount() {
    const { loadPayments: loadAllPayments } = this.props;
    loadAllPayments();
  }

  onClickButton() {
    const { showFilter } = this.state;
    this.setState({
      showFilter: !showFilter,
    });
  }

  onDetails() {
    this.setState({ showModal: true });
  }

  onHideModal() {
    this.setState({ showModal: false });
  }

  getAccountData() {
    const { accountDataById } = this.props;
    return accountDataById[this.getPaymentData().accountData];
  }

  getPaymentData() {
    const { paymentsById, paymentDataById } = this.props;
    const { selectedId } = this.state;
    const payment = paymentsById[selectedId];
    return paymentDataById[payment.paymentData];
  }

  render() {
    const {
      payments, clientsById, terminalsById, accountDataById,
      paymentDataById, pagination, loadPayments: refreshPayments,
    } = this.props;

    const { showModal, selectedId, showFilter } = this.state;

    return (
      <Card style={{ height: '100%' }}>
        <Card.Header className="text-center">
          <strong style={{ fontSize: '22px' }}>Audit Payments</strong>
        </Card.Header>
        <Card.Body>
          <Container>
            <Row>
              <ToolbarContainer pagination={pagination} onPaginationChange={refreshPayments}>
                <PaymentToolbar
                  selectedId={selectedId}
                  onDetails={this.onDetails}
                  onFilter={this.onClickButton}
                  showFilter={showFilter}
                />
              </ToolbarContainer>
            </Row>
            <Collapse in={showFilter}>
              <Row>
                <div id="payment-filter" style={{ width: '100%' }}>
                  <PaymentFilterContainer />
                </div>
              </Row>
            </Collapse>
            <Row>
              <PaymentTable
                payments={payments}
                accountDataById={accountDataById}
                paymentDataById={paymentDataById}
                clientsById={clientsById}
                terminalsById={terminalsById}
                onSelectChange={(id) => this.setState({ selectedId: id })}
                selectedId={selectedId}
              />
              <FormModal
                show={showModal}
                size="lg"
                title="Details"
                isEditing={false}
                onHide={this.onHideModal}
                formId="paymentForm"
              >
                {selectedId ? (
                  <Tabs defaultActiveKey="accountTab" style={{ marginBottom: '1.5rem' }}>
                    <Tab eventKey="accountTab" title="Account Data">
                      <AccountDataForm
                        accountData={this.getAccountData()}
                      />
                    </Tab>
                    <Tab eventKey="paymentData" title="Payment Data">
                      <PaymentDataForm
                        paymentData={this.getPaymentData()}
                      />
                    </Tab>
                  </Tabs>
                ) : null}

              </FormModal>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    );
  }
}

AuditPayments.propTypes = {
  loadPayments: PropTypes.func.isRequired,
  payments: PropTypes.arrayOf(Shapes.PAYMENT),
  paymentsById: PropTypes.objectOf(PropTypes.shape({
    paymentData: PropTypes.number,
  })),
  clientsById: PropTypes.objectOf(PropTypes.shape({})),
  accountDataById: PropTypes.objectOf(PropTypes.shape({})),
  paymentDataById: PropTypes.objectOf(PropTypes.shape({})),
  terminalsById: PropTypes.objectOf(PropTypes.shape({})),
  pagination: Shapes.PAGINATION,
};

AuditPayments.defaultProps = {
  payments: [],
  paymentsById: {},
  clientsById: {},
  accountDataById: {},
  paymentDataById: {},
  terminalsById: {},
  pagination: null,
};

const mapStateToProps = (state) => {
  const {
    pagination: { payments: pagination },
    entities: {
      clients, accountData, paymentData, payments, terminals,
    },
  } = state;

  return {
    pagination,
    payments: pagination.ids ? pagination.ids.map((id) => payments[id]) : [],
    paymentsById: payments,
    clientsById: clients,
    accountDataById: accountData,
    paymentDataById: paymentData,
    terminalsById: terminals,
  };
};

export default connect(mapStateToProps, {
  loadPayments, updatePage, updatePageSize,
})(AuditPayments);
